import * as React from "react";
import * as TabsPrimitive from "@radix-ui/react-tabs";
import { cn } from "@/lib/utils";

export const Tabs = TabsPrimitive.Root;

export const TabsList = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      "flex flex-wrap justify-center gap-3 bg-blue-100/40 p-3 rounded-xl shadow-inner",
      className
    )}
    {...props}
  />
));
TabsList.displayName = TabsPrimitive.List.displayName;

export const TabsTrigger = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      "px-5 py-2.5 rounded-lg font-semibold text-sm transition-all border border-transparent shadow-sm",
      "data-[state=active]:bg-[#1A2B63] data-[state=active]:text-white data-[state=active]:border-[#1A2B63]",
      "data-[state=inactive]:bg-white data-[state=inactive]:text-blue-600 hover:bg-blue-50 hover:text-blue-700",
      "focus-visible:ring-2 focus-visible:ring-blue-400",
      className
    )}
    {...props}
  />
));
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

export const TabsContent = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      "mt-6 bg-white rounded-xl p-6 shadow-lg transition-opacity duration-300",
      className
    )}
    {...props}
  />
));
TabsContent.displayName = TabsPrimitive.Content.displayName;
